import React from 'react';
import { isDeployStaleLoadError, reloadForDeployUpdate } from './deployUpdateRecovery';

// Helper to handle dynamic import failures (e.g., after new deployment)
// When chunks are missing, reload the page to get new chunks
export function lazyWithRetry<T extends React.ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
): React.LazyExoticComponent<T> {
  return React.lazy(() =>
    componentImport().catch((error: Error) => {
      if (isDeployStaleLoadError(error.message)) {
        reloadForDeployUpdate(error.message);
      }
      throw error;
    }),
  );
}
